// @flow
type TPoll = {
    name?: string,
};

type TPollState = {
    data: TPoll,
};

const initialState: TPollState = {
    boxes: {},
    isLoading: true,
    isStickerDragging: false,
};

type TSetPoll = {payload: TPoll, type: 'SET_POLL'};

type TPollActionList = TSetPoll;

function pollReducer(state: TPollState = initialState, {type, payload}: TPollActionList) {
    switch (type) {
        case 'REVIEW_SET_LOAD':
            return state;
        case 'REVIEW_SET_SUCCESS':
            return state;
        case 'REVIEW_SET_FAIL':
            return state;

        case 'REVIEWS_GET_LOAD':
            return {
                ...state,
                isLoading: true,
            };

        case 'REVIEWS_GET_SUCCESS':
            return {
                ...state,
                boxes: {
                    ...state.boxes,
                    ...payload,
                },
                isLoading: false,
            };

        case 'REVIEWS_GET_FAIL':
            return {
                ...state,
                isLoading: false,
            };

        case 'REVIEW_STICKER_DRAG_START':
            return {
                ...state,
                isStickerDragging: true,
            };

        case 'REVIEW_STICKER_DRAG_STOP':
            return {
                ...state,
                isStickerDragging: false,
            };
        case 'SET_POLL_COORDINATES':
            return {
                ...state,
                boxes: {
                    ...state.boxes,
                    ...payload,
                },
            };

        default:
            return state;
    }
}

export {pollReducer};
